import type { ChangeEventHandler } from 'react';

import Input from '~/components/Forms/Input';

import type { SubscriberPreference } from '~/interfaces/subscriber_preferences';

import PreferenceDescription from './PreferenceDescription';
import PreferenceName from './PreferenceName';

interface Props {
  preference: SubscriberPreference;
  onChange: (value: string) => void;
}

const TextField = ({ preference, onChange }: Props) => {
  const handleBlur: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.currentTarget.value.trim() === '') {
      return;
    }

    onChange(e.currentTarget.value);
  };

  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex flex-col gap-y-0.5">
        <PreferenceName name={preference.name} />
        <PreferenceDescription description={preference.description} />
      </div>
      <div className="w-96">
        <Input
          name={`preference-text-field-${preference.id}`}
          placeholder="Enter text here"
          onBlur={handleBlur}
          defaultValue={preference.value}
        />
      </div>
    </div>
  );
};

export default TextField;
